module.exports = {
  context: {
    nodes: [
      {
        id: '44',
        title: 'Our Work',
        url: 'http://adjoin.nitro/our-work',
        active: true,
        children: [
          {
            id: '53',
            title: 'Overview',
            url: 'http://adjoin.nitro/our-work'
          },
          {
            id: '51',
            title: 'Catalysts',
            url: 'http://adjoin.nitro/our-work/catalysts'
          },
          {
            id: '52',
            title: 'Veterans',
            url: 'http://adjoin.nitro/our-work/veterans'
          }
        ]
      },
      {
        id: '45',
        title: 'Our Impact',
        url: 'http://adjoin.nitro/our-impact',
        children: [
          {
            id: '78',
            title: 'Overview',
            url: 'http://adjoin.nitro/our-impact'
          },
          {
            id: '79',
            title: 'Stories',
            url: 'http://adjoin.nitro/our-impact/stories'
          },
          {
            id: '80',
            title: 'One Flutter',
            url: 'http://adjoin.nitro/our-impact/one-flutter'
          },
          {
            id: '81',
            title: 'Annual Reports',
            url: 'http://adjoin.nitro/our-impact/annual-reports'
          },
          {
            id: '82',
            title: 'Financials',
            url: 'http://adjoin.nitro/our-impact/financials'
          }
        ]
      },
      {
        id: '46',
        title: 'Advocacy',
        url: 'http://adjoin.nitro/advocacy',
        children: [
          {
            id: '92',
            title: 'Overview',
            url: 'http://adjoin.nitro/advocacy'
          },
          {
            id: '93',
            title: 'CAC',
            url: 'http://adjoin.nitro/advocacy/cac'
          },
          {
            id: '94',
            title: 'Associations',
            url: 'http://adjoin.nitro/advocacy/associations'
          },
          {
            id: '95',
            title: 'Initiatives',
            url: 'http://adjoin.nitro/advocacy/initiatives'
          }
        ]
      },
      {
        id: '47',
        title: 'Join Us',
        url: 'http://adjoin.nitro/join-us',
        children: [
          {
            id: '109',
            title: 'Overview',
            url: 'http://adjoin.nitro/join-us'
          },
          {
            id: '110',
            title: 'Why Join Adjoin',
            url: 'http://adjoin.nitro/join-us/why-join-adjoin'
          },
          {
            id: '111',
            title: 'Careers',
            url: 'http://adjoin.nitro/join-us/careers'
          },
          {
            id: '112',
            title: 'Partnerships',
            url: 'http://adjoin.nitro/join-us/partnerships'
          },
          {
            id: '113',
            title: 'Volunteers',
            url: 'http://adjoin.nitro/join-us/volunteers'
          }
        ]
      },
      {
        id: '48',
        title: 'Who We Are',
        url: 'http://adjoin.nitro/who-we-are',
        children: [
          {
            id: '114',
            title: 'Overview',
            url: 'http://adjoin.nitro/who-we-are'
          },
          {
            id: '157',
            title: 'Mission, Vision & Values',
            url: 'http://adjoin.nitro/who-we-are/mission-vision-values'
          },
          {
            id: '158',
            title: 'History',
            url: 'http://adjoin.nitro/who-we-are/history'
          },
          {
            id: '159',
            title: 'Our Team',
            url: 'http://adjoin.nitro/who-we-are/our-team'
          },
          {
            id: '160',
            title: 'Board',
            url: 'http://adjoin.nitro/who-we-are/board'
          }
        ]
      },
      {
        id: '49',
        title: 'Ways To Give',
        url: 'http://adjoin.nitro/ways-to-give',
        children: [
          {
            id: '161',
            title: 'Overview',
            url: 'http://adjoin.nitro/ways-to-give'
          },
          {
            id: '162',
            title: 'Donate',
            url: 'http://adjoin.nitro/ways-to-give/donate'
          },
          {
            id: '163',
            title: 'Gift Catalog',
            url: 'http://adjoin.nitro/ways-to-give/gift-catalog'
          },
          {
            id: '164',
            title: 'Fundraising Initiatives',
            url: 'http://adjoin.nitro/ways-to-give/fundraising-initiatives'
          }
        ]
      },
      {
        id: '50',
        title: 'The Latest',
        url: 'http://adjoin.nitro/the-latest',
        children: [
          {
            id: '165',
            title: 'Overview',
            url: 'http://adjoin.nitro/the-latest'
          },
          {
            id: '166',
            title: 'WWN',
            url: 'http://adjoin.nitro/the-latest/wwn'
          },
          {
            id: '167',
            title: 'Podcast',
            url: 'http://adjoin.nitro/the-latest/podcast'
          },
          {
            id: '168',
            title: 'Events',
            url: 'http://adjoin.nitro/the-latest/events'
          },
          {
            id: '169',
            title: 'Social Media',
            url: 'http://adjoin.nitro/the-latest/social-media'
          },
          {
            id: '170',
            title: 'VLOG',
            url: 'http://adjoin.nitro/the-latest/vlog'
          },
          {
            id: '171',
            title: 'Newsletter',
            url: 'http://adjoin.nitro/the-latest/newsletter'
          },
          {
            id: '172',
            title: 'Press Release',
            url: 'http://adjoin.nitro/the-latest/press-release'
          }
        ]
      }
    ],
    donate: '@top-utility-navigation.donate',
    contact: '@top-utility-navigation.contact',
    topNav: '@top-navigation'
  }
}
